interface IconGalleryProps {
  active?: boolean;
}
export const IconGallery = ({ active }: IconGalleryProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 13.125V18.4688C21 19.8667 19.8667 21 18.4688 21H5.53125C4.13328 21 3 19.8667 3 18.4688V5.53125C3 4.13328 4.13328 3 5.53125 3H10.875"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 10.875L3 5.53125C3 4.13328 4.13328 3 5.53125 3L18.4688 3C19.8667 3 21 4.13328 21 5.53125L21 18.4688C21 19.8667 19.8667 21 18.4688 21L13.125 21"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 15.8751L7.76216 10.7161C8.57325 9.83746 9.88829 9.83746 10.6994 10.7161L15.4615 15.8751M14.0769 14.3751L15.3775 12.9661C16.1886 12.0875 17.5037 12.0875 18.3148 12.9661L21 15.8751"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.25 7.375H15.2575V7.3825H15.25V7.375Z"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.625 7.375C15.625 7.58211 15.4571 7.75 15.25 7.75C15.0429 7.75 14.875 7.58211 14.875 7.375C14.875 7.16789 15.0429 7 15.25 7C15.4571 7 15.625 7.16789 15.625 7.375Z"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
